module.exports = __webpack_public_path__ + "static/media/area.0cbe29d3.svg";